<p-drawer
  [visible]="visible()"
  (onHide)="onDrawerHide()"
  position="right"
  ariaCloseLabel="Cerrar"
  [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
  class="!w-96"
  header="Configuraciones">
  <div class="flex flex-col gap-6">
    <div>
      <div class="flex flex-col gap-2">
        <span class="text-lg text-muted-color font-semibold">Modo de color</span>
        <p-selectbutton
          [ngModel]="darkTheme()"
          (ngModelChange)="toggleDarkMode()"
          [options]="themeOptions"
          optionLabel="name"
          optionValue="value"
          [allowEmpty]="false"></p-selectbutton>
      </div>
    </div>
    <div class="flex flex-col gap-2">
      <span class="text-lg text-muted-color font-semibold">Tipo de menú</span>
      <div class="flex flex-col gap-3">
        <div class="flex items-center gap-2 w-6/12">
          <p-radio-button
            name="menuMode"
            value="static"
            [ngModel]="menuMode()"
            (ngModelChange)="setMenuMode('static')"
            inputId="static"></p-radio-button>
          <label for="static">Estático</label>
        </div>
        <div class="flex items-center gap-2 w-6/12">
          <p-radio-button
            name="menuMode"
            value="overlay"
            [ngModel]="menuMode()"
            (ngModelChange)="setMenuMode('overlay')"
            inputId="overlay"></p-radio-button>
          <label for="overlay">Superposición</label>
        </div>
        <div class="flex items-center gap-2 w-6/12">
          <p-radio-button
            name="menuMode"
            value="reveal"
            [ngModel]="menuMode()"
            (ngModelChange)="setMenuMode('reveal')"
            inputId="reveal"></p-radio-button>
          <label for="reveal">Revelar</label>
        </div>
      </div>
    </div>
  </div>
</p-drawer>
